var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-row',{attrs:{"no-gutters":"","justify":"center"}},[_vm._t("skeleton"),(!_vm.$slots.skeleton)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e()],2):(!!_vm.loaded)?[_vm._t("default")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }